// extracted by mini-css-extract-plugin
export default {"import_system":"ImportSystem_import_system__zECMW","import_system__logo":"ImportSystem_import_system__logo__Gckq9","spin":"ImportSystem_spin__tBHQp"};